import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'mmx-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  standalone: false,
})
export class ConfirmComponent implements AfterViewInit {
  @ViewChild('confirmButton') confirmButtonEl: ElementRef | undefined

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      iconColor?: string
      icon?: string
      message?: string
      hideNoButton?: boolean
      yesBtnLabel?: string
      translationTokens?: Record<string, string>
    },
  ) {}

  ngAfterViewInit() {
    if (this.confirmButtonEl && this.confirmButtonEl.nativeElement) {
      this.confirmButtonEl.nativeElement.focus()
    }
  }
}
